<template>
  <aha-modal @hide="hide()" :title="modalTitle">
    <div :inner-html.prop="modalContent" />
    <template #action>
      <aha-button
        variant="danger"
        :disabled="isDeletingFolder"
        @click="handleDeleteFolder()"
        icon-name="delete"
        :submitting="isDeletingFolder"
        has-margin-right
      >
        <aha-spinner variant="white" class="mr-1" v-if="isDeletingFolder" />
        {{ $i18nPresenter.t("Delete") }}
      </aha-button>
      <aha-link @click="hide()">
        <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'

// api
import FolderApi from '@/api/folder'

// constants
import eventCategories from '@/constant/eventCategories'

// utils
import utils from '@/util'

export default {
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDeletingFolder: false,
      sumOfSubFolders: 0,
      deletedFolderId: [],
      deletedPresentationId: [],
    }
  },
  computed: {
    ...mapState({
      folders: (state) => state.folders,
      currentFolderDepth: (state) => state.currentFolderDepth,
    }),
    ...mapGetters(['getPresenterLocale']),
    modalTitle() {
      if (this.getPresenterLocale === 'en') {
        return `Delete ${this.folder.folderName} folder`
      }
      return this.$i18nPresenter.t('Remove confirmation')
    },
    hasPresentationsInside() {
      return this.folder.countPresentationRecursive && this.folder.countPresentationRecursive > 0
    },
    modalContent() {
      return `You're about to permanently delete <span class="font-bold">${utils.sanitize(this.folder.folderName)}</span> folder and its <span class="font-bold">${this.folder.countPresentationRecursive} ${this.folder.countPresentationRecursive > 1
        ? 'presentations' : 'presentation'}</span>.`
    },
  },
  methods: {
    ...mapActions([
      'setFoldersAction',
      'setErrorOnInternalServerAction',
    ]),
    handleAfterCallAPIDeleteFolder() {
      utils.showToastSuccess(`${this.$i18nPresenter.t('Deleted folder')} "${utils.sanitize(this.folder.folderName)}"`)
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Succeeded', null, null, {
        parentFolderId: this.selectedFolderId,
        folderDepth: this.currentFolderDepth || 0,
        deletedFolderId: this.deletedFolderId,
        deletedPresentationId: this.deletedPresentationId,
      })
      const index = this.folders.findIndex((folder) => {
        return folder.folderId === this.folder.folderId
      })
      this.folders.splice(index, 1)
      this.setFoldersAction(this.folders)
    },
    async handleDeleteFolder() {
      this.isDeletingFolder = true
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Submit', null, null, {
        parentFolderId: this.selectedFolderId,
        folderDepth: this.currentFolderDepth || 0,
      })
      try {
        const { deletedFolderIds, deletedPresentationIds } = await FolderApi.removeFolderById(this.folder.folderId)
        this.deletedFolderId = deletedFolderIds.map((folder) => folder.folderId)
        this.deletedPresentationId = deletedPresentationIds.map((presentation) => presentation.id)
        this.handleAfterCallAPIDeleteFolder()
      } catch {
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Failed', null, null, {
          parentFolderId: this.selectedFolderId,
          folderDepth: this.currentFolderDepth || 0,
          deletedFolderId: this.deletedFolderId,
          deletedPresentationId: this.deletedPresentationId,
        })
        this.setErrorOnInternalServerAction(`Cannot delete folder ${this.folder.folderName}`)
      } finally {
        this.isDeletingFolder = false
        this.hide()
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
